function addToCartsingle(variantId, addToCartBtn) { 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json', 
      success: function (data) { 
        var product = data;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: addToCartBtn
          }
        }));
      },
      error: function(xhr, status, error) {
        console.error('Error adding product to cart:', error);
      }
    });
  }
  


var swiper = new Swiper(".mprogSwiper", {
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  navigation: {
    nextEl: ".m-swiper-button-next",
    prevEl: ".m-swiper-button-prev",
  },
});
function initMRecProdSlider() {
  var swiper = new Swiper(".M-Rec-Prod-Swiper", {
    slidesPerView: 2,
    spaceBetween: 0,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
},
  });
}

function initMCSSlider() {
  var swiper = new Swiper(".M-mcs-Swiper", {
    slidesPerView: 1.2,
    spaceBetween: 30,
    navigation: {
      nextEl: ".m-mcs-next",
      prevEl: ".m-mcs-prev",
    },
      breakpoints: {
        950: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },    
  });
}
